const ResourceTypes = {
  AnalysisServices: "microsoft.analysisservices/servers",
  ApiManagementService: "microsoft.apimanagement/service",
  ApplicationGateways: "microsoft.network/applicationgateways",
  ApplicationGatewayforContainers: "microsoft.servicenetworking/trafficcontrollers",
  ApplicationInsights: "microsoft.insights/components",
  AppServiceEnvironments: "microsoft.web/hostingenvironments",
  AppServicePlans: "microsoft.web/serverfarms",
  AppServices: "microsoft.web/sites",
  ArcMachines: "microsoft.hybridcompute/machines",
  AutomationAccounts: "microsoft.automation/automationaccounts",
  AutonomousDatabases: "oracle.database/autonomousdatabases",
  AutoscaleSettings: "microsoft.insights/autoscalesettings",
  AzureAD: "microsoft.aadiam/azureadmetrics",
  AzureADDomainServices: "microsoft.aad/domainservices",
  AzureDatabricks: "microsoft.databricks/workspaces",
  AzureBotService: "microsoft.botservice/botservices",
  AzureElasticSAN: "microsoft.elasticsan/elasticsans",
  AzureResourceManager: "microsoft.resources/subscriptions",
  AzureSpringCloud: "microsoft.appplatform/spring",
  AzureStackHCI: "microsoft.azurestackhci/clusters",
  AzureVMWarePrivateClouds: "microsoft.avs/privateclouds",
  AzsResourceMonitor: "microsoft.azurestackresourcemonitor/storageaccountmonitor",
  // AzureStack Resource
  BackupVaults: "microsoft.dataprotection/backupvaults",
  BareMetalMachine: "microsoft.networkcloud/baremetalmachines",
  Bastion: "microsoft.network/bastionhosts",
  BatchAccounts: "microsoft.batch/batchaccounts",
  BatchAi: "microsoft.batchai/workspaces",
  CdnProfile: "microsoft.cdn/profiles",
  CdnWafPolicy: "microsoft.cdn/cdnwebapplicationfirewallpolicies",
  ClassicCloudServices: "microsoft.classiccompute/domainnames",
  CloudServiceExtendedSupport: "microsoft.compute/cloudservices",
  ClassicComputeVirtualMachines: "microsoft.classiccompute/virtualmachines",
  CloudSimple: "microsoft.vmwarecloudsimple/virtualmachines",
  // 3rd party resource
  Cluster: "microsoft.networkcloud/clusters",
  ClusterManagers: "microsoft.networkcloud/clustermanagers",
  CognitiveServices: "microsoft.cognitiveservices/accounts",
  CommunicationsGateways: "microsoft.voiceservices/communicationsgateways",
  CodeSigningAccounts: "microsoft.codesigning/codesigningaccounts",
  ConfigurationStores: "microsoft.appconfiguration/configurationstores",
  Connections: "microsoft.network/connections",
  ConnectedVehicle: "microsoft.connectedvehicle/platformaccounts",
  ContactProfiles: "microsoft.orbital/contactprofiles",
  ContainerApps: "microsoft.app/containerapps",
  ContainerAppsEnvironment: "microsoft.app/managedenvironments",
  ContainerGroups: "microsoft.containerinstance/containergroups",
  ContainerRegistries: "microsoft.containerregistry/registries",
  ContainerServicesManaged: "microsoft.containerservice/managedclusters",
  CosmosDB: "microsoft.documentdb/databaseaccounts",
  CosmosCassandra: "microsoft.documentdb/cassandraClusters",
  CosmosMongo: "microsoft.documentdb/mongoClusters",
  CustomerInsights: "microsoft.customerinsights/hubs",
  CustomMetricUsage: "microsoft.insights/qos",
  DataboxEdge: "microsoft.databoxedge/databoxedgedevices",
  DataFactories: "microsoft.datafactory/datafactories",
  DataFactoriesv2: "microsoft.datafactory/factories",
  DataCollectionRules: "microsoft.insights/datacollectionrules",
  DataLakeAnalytics: "microsoft.datalakeanalytics/accounts",
  DataLakeStore: "microsoft.datalakestore/accounts",
  DataShare: "microsoft.datashare/accounts",
  DBForMySql: "microsoft.dbformysql/servers",
  DeviceProvisioningServices: "microsoft.devices/provisioningservices",
  DevCenters: "microsoft.devcenter/devcenters",
  Disks: "microsoft.compute/disks",
  DNSZones: "microsoft.network/dnszones",
  DNSPrivateResolver: "microsoft.network/dnsresolvers",
  DNSForwardingRuleset: "microsoft.network/dnsforwardingrulesets",
  EnterpriseGraph: "microsoft.enterpriseknowledgegraph/services",
  EventGridDomains: "microsoft.eventgrid/domains",
  EventGridTopics: "microsoft.eventgrid/topics",
  EventGridSystemTopics: "microsoft.eventgrid/systemtopics",
  EventHubs: "microsoft.eventhub/namespaces",
  EventHubsClusters: "microsoft.eventhub/clusters",
  ExpressRouteCircuits: "microsoft.network/expressroutecircuits",
  ExpressRouteGateways: "microsoft.network/expressroutegateways",
  ExpressRoutePorts: "microsoft.network/expressrouteports",
  FabricLocations: "microsoft.fabric.admin/fabriclocations",
  // AzureStack Resource
  Firewall: "microsoft.network/azurefirewalls",
  FrontDoor: "microsoft.network/frontdoors",
  Grafana: "microsoft.dashboard/grafana",
  HDInsights: "microsoft.hdinsight/clusters",
  IoTCentralApplications: "microsoft.iotcentral/iotapps",
  IoTHub: "microsoft.devices/iothubs",
  IotSpaces: "microsoft.iotspaces/graph",
  KeyVault: "microsoft.keyvault/vaults",
  KubernetesArc: "microsoft.kubernetes/connectedclusters",
  KustoClusters: "microsoft.kusto/clusters",
  Layer2IsolationDomain: "microsoft.managednetworkfabric/l2isolationdomains",
  Layer3IsolationDomain: "microsoft.managednetworkfabric/l3isolationdomains",
  LoadBalancers: "microsoft.network/loadbalancers",
  LogAnalytics: "microsoft.operationalinsights/workspaces",
  LogicApps: "microsoft.logic/workflows",
  LogicIntegrationServiceEnvironment: "microsoft.logic/integrationserviceenvironments",
  MachineLearningServiceWorkspace: "microsoft.machinelearningservices/workspaces",
  MariaDB: "microsoft.dbformariadb/servers",
  ManagedHsms: "microsoft.keyvault/managedhsms",
  ManagedLustre: "microsoft.storagecache/amlfilesystems",
  ManagedNetworkFabricNetworkDevices: "microsoft.managednetworkfabric/networkdevices",
  MediaServices: "microsoft.media/mediaservices",
  MonitorAccounts: "microsoft.monitor/accounts",
  MySQLFlexibleServers: "microsoft.dbformysql/flexibleservers",
  NatGateway: "microsoft.network/natgateways",
  NetworkInterfaces: "microsoft.network/networkinterfaces",
  NetworkVirtualAppliances: "microsoft.network/networkvirtualappliances",
  NetAppCapacityPools: "microsoft.netapp/netappaccounts/capacitypools",
  NetworkWatcher: "microsoft.network/networkwatchers",
  NGINXaaS: "nginx.nginxplus/nginxdeployments",
  ConnectionMonitor: "microsoft.network/networkwatchers/connectionmonitors",
  NotificationHubs: "microsoft.notificationhubs/namespaces/notificationhubs",
  OracleExadataVMCluster: "oracle.database/cloudvmclusters",
  OracleExadbVMCluster: "oracle.database/exadbVmClusters",
  OrbitalL2Connections: "microsoft.orbital/l2connections",
  MobileNetworkSite: "microsoft.mobilenetwork/mobilenetworks/sites",
  RadioAccessNetwork: "microsoft.mobilenetwork/radioaccessnetworks",
  PacketCoreControlPlane: "microsoft.mobilenetwork/packetcorecontrolplanes",
  PacketCoreDataPlane: "microsoft.mobilenetwork/packetcorecontrolplanes/packetcoredataplanes",
  PeeringServices: "microsoft.peering/peeringservices",
  PlayFabTitles: "microsoft.playfab/titles",
  PointToSiteVPN: "microsoft.network/p2svpngateways",
  PostgreSQLFlexibleServers: "microsoft.dbforpostgresql/flexibleservers",
  PostgreSQLServers: "microsoft.dbforpostgresql/servers",
  PostgreSQLServersV2: "microsoft.dbforpostgresql/serversv2",
  PowerBIDedicatedCapacities: "microsoft.powerbidedicated/capacities",
  PrivateEndpoint: "microsoft.network/privateendpoints",
  PrivateLinkService: "microsoft.network/privatelinkservices",
  ProviderMonitorSettings: "Microsoft.ProviderHub/providerMonitorSettings",
  ProvisionedClusters: "microsoft.hybridcontainerservice/provisionedclusters",
  PublicIPAddresses: "microsoft.network/publicipaddresses",
  PublicIPPrefixes: "microsoft.network/publicipprefixes",
  RecoveryServicesVault: "microsoft.recoveryservices/vaults",
  RedisCaches: "microsoft.cache/redis",
  RedisEnterprise: "microsoft.cache/redisenterprise",
  Relay: "microsoft.relay/namespaces",
  SearchServices: "microsoft.search/searchservices",
  ServerGroups: "microsoft.dbforpostgresql/servergroupsv2",
  ServiceBus: "microsoft.servicebus/namespaces",
  ServiceFabricMesh: "microsoft.servicefabricmesh/applications",
  SignalRService: "microsoft.signalrservice/signalr",
  SignalRServiceWebPubSub: "microsoft.signalrservice/webpubsub",
  Solutions: "microsoft.operationsmanagement/solutions",
  Spacecrafts: "microsoft.orbital/spacecrafts",
  SqlManaged: "microsoft.sql/managedinstances",
  SqlServersDatabases: "microsoft.sql/servers/databases",
  SqlServersElasticPools: "microsoft.sql/servers/elasticpools",
  SqlServersElasticJobAgents: "microsoft.sql/servers/jobagents",
  StaticSites: "Microsoft.web/staticSites",
  Storage: "microsoft.storage/storageaccounts",
  StorageAppliance: "microsoft.networkcloud/storageappliances",
  StorageCaches: "microsoft.storagecache/caches",
  StorageMover: "microsoft.storagemover/storagemovers",
  StorageClassic: "microsoft.classicstorage/storageaccounts",
  StorageSync: "microsoft.storagesync/storagesyncservices",
  StreamAnalyticsJobs: "microsoft.streamanalytics/streamingjobs",
  SynapseWorkspace: "microsoft.synapse/workspaces",
  TimeseriesInsightsEnvironments: "microsoft.timeseriesinsights/environments",
  TrafficManagerProfiles: "microsoft.network/trafficmanagerprofiles",
  VirtualHubs: "microsoft.network/virtualhubs",
  VirtualMachines: "microsoft.compute/virtualmachines",
  VirtualMachinesScaleSets: "microsoft.compute/virtualmachinescalesets",
  VirtualNetworkFunctions: "microsoft.hybridnetwork/virtualnetworkfunctions",
  VirtualNetworkGateWays: "microsoft.network/virtualnetworkgateways",
  VirtualWANs: "microsoft.network/virtualwans",
  VPNGateways: "microsoft.network/vpngateways",
  WebsitesSlots: "microsoft.web/sites/slots",
  WorkerPools: "microsoft.web/hostingenvironments/workerpools",
  ActivityLogAlertRules: "microsoft.insights/activitylogalerts",
  MetricAlertRules: "microsoft.insights/metricalerts",
  LogAlertRules: "microsoft.insights/scheduledqueryrules",
  ActionGroups: "microsoft.insights/actiongroups",
  AlertProcessingRules: "microsoft.alertsmanagement/actionrules",
  SmartAlertRules: "microsoft.alertsmanagement/smartdetectoralertrules",
  PrometheusRuleGroups: "microsoft.alertsmanagement/prometheusrulegroups"
};

export { ResourceTypes };
//# sourceMappingURL=ResourceTypes.js.map
